import Linechart from './Linechart';

export default Linechart;
